import { useContext } from "react";

import { SuggestedAgendaItemContext } from "./SuggestedAgendaItemContext";

export function useSuggestedAgendaItem() {
  const context = useContext(SuggestedAgendaItemContext);
  if (!context) {
    throw new Error("useSuggestedAgendaItem must be used within a SuggestedAgendaItemProvider");
  }
  return context;
}
